<div class="card" *ngIf="user">
  <div class="user-header">
    <span>
      {{ 'manageUsers.userInfo.accountInfo' | translate }}
    </span>
  </div>
  <form [formGroup]="form">
    <div class="user-row">
      <div><strong>{{ 'manageUsers.userInfo.form.userId' | translate }}</strong> {{ user._id }}</div>
      <div><strong>{{ 'manageUsers.userInfo.form.loggingId' | translate }}</strong> {{ user.user_id }}</div>
    </div>
    <div class="user-row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'manageUsers.userInfo.form.firstName' | translate }}</mat-label>
        <mat-error *ngIf="form.get('firstname').errors"> {{ getErrorText('firstname') }}</mat-error>
        <input test-id="first-name-input" matInput formControlName="firstname">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'manageUsers.userInfo.form.lastName' | translate }}</mat-label>
        <mat-error *ngIf="form.get('lastname').errors">{{ getErrorText('lastname') }}</mat-error>
        <input test-id="last-name-input" matInput formControlName="lastname">
      </mat-form-field>
    </div>
    <div class="user-row">
      <mat-form-field appearance="outline">
        <mat-label>{{ 'manageUsers.userInfo.form.email' | translate }}</mat-label>
        <input test-id="email-input" matInput formControlName="email">
      </mat-form-field>
      <mat-form-field appearance="outline">
        <mat-label>{{ 'manageUsers.userInfo.form.role' | translate }}</mat-label>
        <mat-select test-id="role-select" formControlName="role">
          <mat-option *ngFor="let role of roleOptions" [disabled]="role.disabled" [value]="role.value">{{ role.label }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="user-row" style="align-items: center;">
      <mat-slide-toggle test-id="disabled-user-toggle" formControlName="disabled" style="flex-grow: 0" [matTooltip]="form.get('disabled').disabled ? ('manageUsers.userInfo.form.loginWontDisable' | translate) : null">
        {{ 'manageUsers.userInfo.form.loginDisabled' | translate }}
      </mat-slide-toggle>
      <span test-id="ldap-warning" *ngIf="ldapEnabled" style="flex-grow: initial">{{ 'manageUsers.userInfo.form.ldapWarning' | translate }}</span>
    </div>
    <div mat-dialog-actions align="end">
      <button test-id="cancel-button" mat-stroked-button (click)="resetFormGroup()">{{ 'common.actions.cancel' | translate }}</button>
      <button test-id="save-button" mat-flat-button color="primary" [disabled]="!form.valid" (click)="save()">{{ 'common.actions.save' | translate }}</button>
    </div>
  </form>
</div>
